"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportElementTypes = void 0;
var ReportElementTypes;
(function (ReportElementTypes) {
    ReportElementTypes["Dashboard"] = "dashboard";
    ReportElementTypes["Look"] = "look";
    ReportElementTypes["Folder"] = "folder";
    ReportElementTypes["explore"] = "explore";
})(ReportElementTypes || (exports.ReportElementTypes = ReportElementTypes = {}));
